import {
  GetInvoiceReportRequestDto,
  GetRepairReportRequestDto,
  ReportParameter
} from '../interfaces/Reports';
import { IReportsService } from './Interfaces/IReportsService';

import { API } from '../helpers/API';
import { InvoiceReportResult } from '../interfaces/Case';

export class ReportsService implements IReportsService {
  private baseController = '/case';

  public async GetReport(code: string, parameters: ReportParameter[]): Promise<Blob> {
    return (
      await API.PostFileAsync<ReportParameter[], Blob>(
        `${this.baseController}/report/${code}`,
        parameters
      )
    ).data;
  }

  public async GetInOutReport(
    code: string,
    caseId: number,
    appointmentId: number,
    parameters: ReportParameter[]
  ): Promise<Blob> {
    return (
      await API.PostFileAsync<ReportParameter[], Blob>(
        `${this.baseController}/${caseId}/${appointmentId}/report/${code}`,
        parameters
      )
    ).data;
  }

  public async GetInvoiceReport(
    code: string,
    caseId: number,
    request: GetInvoiceReportRequestDto
  ): Promise<InvoiceReportResult> {
    return (
      await API.Post2Async<GetInvoiceReportRequestDto, InvoiceReportResult>(
        `${this.baseController}/${caseId}/invoice/${code}`,
        request
      )
    ).data;
  }

  public async GetRepairReport(request: GetRepairReportRequestDto): Promise<Blob> {
    return (
      await API.PostFileAsync<GetRepairReportRequestDto, Blob>(
        `${this.baseController}/repair-report`,
        request
      )
    ).data;
  }
}
